import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import screenerSlice, {
  screenerSelectors,
} from 'features/screener/slice';
import {
  ICalcsScreenerSaveOrRunResult,
  IRulesScreenerSaveOrRunResult,
} from 'features/screener/types';
import { emptyObject } from 'utils/general';
import { ContainerResult, ResultPaginationInfo } from './styled';

const ScreenerPagination = () => {
  const {
    screenerResult: { data: screenerResult },
    screenerPostResult: { data: screenerPostResult },
  } = useSelector(screenerSelectors);

  const { setIsModalAddColumnActive } = screenerSlice.actions;

  const dataScreenerResult =
    !emptyObject(screenerPostResult)
      ? screenerPostResult
      : screenerResult;

  const dispatch = useDispatch();

  const [paginationAttributes, setPaginationAttributes] = useState<{
    totalrows?: number;
    curpage?: number;
    perpage?: number;
    calcs?: ICalcsScreenerSaveOrRunResult[];
    sort?: string;
    order?: number;
    universe?: string;
    rules?: IRulesScreenerSaveOrRunResult[];
    sequence?: string[];
    screenerid?: number;
    screen_name?: string;
    screen_desc?: string;
  }>({});

  const {
    calcs,
    curpage,
    perpage,
    totalrows,
  } = paginationAttributes;

  const screenerNumberPaginationStart = () => {
    if (curpage === 1) return 1;
    return perpage * curpage - perpage + 1;
  };

  const screenerNumberPaginationEnd = () => {
    if (curpage === 1) return calcs.length;

    return curpage * calcs?.length < totalrows
      ? perpage * curpage - perpage + calcs?.length
      : totalrows;
  };

  const showModalFinancial = () => {
    dispatch(setIsModalAddColumnActive(true));
  };

  useEffect(() => {
    const {
      totalrows: totalrowsResult,
      curpage: curpageResult,
      perpage: perpageResult,
      calcs: calcsResult,
      sort: sortResult,
      order: orderResult,
      universe: universeResult,
      rules: rulesResult,
      sequence: sequenceResult,
      screenerid: screeneridResult,
      ...restScreenerResult
    } = dataScreenerResult;

    setPaginationAttributes((prevState) => ({
      ...prevState,
      ...restScreenerResult,
      calcs: calcsResult,
      perpage: perpageResult,
      curpage: curpageResult,
      totalrows: totalrowsResult,
      sort: sortResult,
      order: orderResult,
      universe: universeResult,
      rules: rulesResult,
      sequence: sequenceResult,
      screenerid: screeneridResult,
    }));
  }, [dataScreenerResult]);

  return (
    totalrows > 0 && (
      <ContainerResult>
        <ResultPaginationInfo>
          Results {screenerNumberPaginationStart()} -{' '}
          {screenerNumberPaginationEnd()} of {totalrows} Equities
        </ResultPaginationInfo>
        {/* @ts-expect-error */}
        <Button type="borderless" pr="0px" onClick={showModalFinancial}>
          <Flex align="center">
            <Iconmoon className="icon-compose_plus" color="midgray" />
            {/* @ts-expect-error */}
            <Text ml="5px" color={color.primary}>
              Add Financial Column
            </Text>
          </Flex>
        </Button>
      </ContainerResult>
    )
  );
};

export default ScreenerPagination;
